// extracted by mini-css-extract-plugin
module.exports = {"countDown":"index_countDown__YeCl5","countDownIng":"index_countDownIng__WWW4S","darkCountDown":"index_darkCountDown__S_gI3"};